export const routeTitles: Record<string, string> = {
    "/afisha": "Афиша",
    "/afisha/film": "Фильм",
    "/tickets": "Мои билеты",
    "/contacts": "Контакты",
    "/news": "Новости",
    "/promo": "Акции",
    "/more": "Ещё",
    "/privacy": "Политика конфиденциальности",
    "/personal-data": "Обработка персональных данных",
    "/terms": "Пользовательское соглашение",
    "/purchase-terms": "Условия покупки и возврата",
    "/profile/edit": "Настройки профиля",
    "/profile/about": "FAQ",
    "/profile/favourites": "Избранное",
    "/profile/history": "История покупок",
    "/profile/promocode": "Промокод",
    "/profile/notifications": "Уведомления",
    "/profile/support": "Чат тех. поддержки"
}
